import React, { FunctionComponent } from 'react';
import styles from './award-with-stars-and-image.module.scss';

export interface IImageWithDescription {
  url: string;
  description: string;
}

export interface IAwardWithStarsAndImageProps {
  starText: string;
  starsImage: IImageWithDescription;
  awardImage1: IImageWithDescription;
  awardImage2: IImageWithDescription;
  awardImage3: IImageWithDescription;
}

export const AwardWithStarsAndImage: FunctionComponent<IAwardWithStarsAndImageProps> = ({
  starText,
  starsImage,
  awardImage1,
  awardImage2,
  awardImage3
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.rateWrapper}>
        <span className={styles.starText}>{starText}</span>
        <img src={starsImage.url} alt={starsImage.description} />
      </div>
      <div className={styles.awardImagesWrapper}>
        <img src={awardImage1.url} alt={awardImage1.description} />
        <img src={awardImage2.url} alt={awardImage2.description} />
        <img src={awardImage3.url} alt={awardImage3.description} />
      </div>
    </div>
  );
};
